export const COLORS = {
  primary: {
    main: 'rgb(255, 196, 12)',
    // main:'#2e7d32',
    light: '#42a5f5',
    dark: '#bb8a05',
  },
  secondary: {
    main: '#000000',
    light: '#ba68c8',
    dark: '#7b1fa2',
  },
  text: {
    primary: '#000000',
    secondary: '#30333a',
    disabled: 'rgba(0, 0, 0, 0.38)',
    label: '#676a6d',
    placeholder: 'rgba(0, 0, 0, 0.38)',
  },
  background: {
    main: 'rgb(76, 10, 39)',
    default: '#ffffff',
    paper: '#ffffff',
    input: '#f5f5f5',
  },
  border: {
    default: '#dddddd',
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
  },
  success: {
    main: '#2e7d32',
    light: '#4caf50',
    dark: '#1b5e20',
  },
  warning: {
    main: '#ed6c02',
    light: '#ff9800',
    dark: '#e65100',
  },
  info: {
    main: '#0288d1',
    light: '#03a9f4',
    dark: '#01579b',
  },
   sidebar: {
    // Change this to your desired sidebar color
    main: 'rgb(0, 0, 0)',
  },
};

export const FONTS = {
  family: {
    primary: 'Livvic',
  },
  size: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    xxl: '24px',
  },
  weight: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
  },
};

export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
};

export const BORDER_RADIUS = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  round: '50%',
};

export const FIELD_WIDTHS = {
  xs: '150px', // For small fields like delivery time
  sm: '200px', // For fields like minimum order amount
  md: '250px', // For fields like phone number
  lg: '400px', // For fields like restaurant name and select fields
  xl: '700px', // For larger fields
  full: '100%', // For full width fields
};
